const componentWrapperCls = "_uihczed5if";

export { componentWrapperCls };
import "./embed-iframe.style.linaria.module.css";
//# sourceMappingURL=embed-iframe.style.js.map
